import { Component, Input } from '@angular/core';
import { Direction } from '../../../models/direction.enum';
import { LineItem } from '../../../models/lineitem';

@Component({
  selector: 'detail-authority-card-mobile',
  templateUrl: './detail-authority-card-mobile.component.html',
  styleUrls: ['./detail-authority-card-mobile.component.scss']
})
export class DetailAuthorityCardMobileComponent {
  @Input() lineItem: LineItem;
  Direction = Direction;
}
